import { AvailableExports, OptionsMap } from './types';

export const populateOptions = (availableExports: AvailableExports, map: OptionsMap) => {
  return Object.keys(availableExports)
    .filter((key) => availableExports[key as keyof AvailableExports])
    .map((key) => {
      return map[key];
    });
};
